import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

export class BaryComponentHelper {
  static genId(id: string, prefix = '', suffix: string | number = ''): string {
    let value = id;
    if (prefix) {
      value += '-' + prefix;
    }
    if (suffix) {
      value += '-' + suffix;
    }
    return value;
  }

  static makeId(): string {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < 6; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  static copy<T>(objectToCopy: T): T {
    return JSON.parse(JSON.stringify(objectToCopy)) as T;
  }

  static generateAction<T>(): Subject<T> {
    const action = new Subject<T>();
    action.pipe(debounceTime(200));
    return action;
  }
}
